import * as React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import './BarTabs.css';
import { useWindowSize } from '../../utils/utils';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function BarTabs({ items }) {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const phoneScreen = useWindowSize() <= 700;
  const heightTabs = phoneScreen ? '80vh' : '50vh' ;

  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%', height: heightTabs }}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="full width tabs example"
          variant="scrollable"
        >
        {
          items.map((item, index) => {
            return (
              <Tab
                label={item.name}
                {...a11yProps(index)}
                key={`tab-${index}`}
              />
            )
          })
        }
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {
          items.map((item, index) => {
            return (
              <TabPanel value={value} index={index} dir={theme.direction} key={`tab-panel-${index}`}>
                <div className="BarTabs-role">
                  <span className="BarTabs-h2">{item.role}</span>
                </div>
                <div className="BarTabs-date">
                  {item.date}
                </div>
                <div className="BarTabs-goal-container">
                  <ul>
                    {
                      item.goals.map(goal => {
                        return (
                          <li className="BarTabs-goal" key={`li-${goal}`}>{goal}</li>
                        )
                      })
                    }
                  </ul>
                </div>
              </TabPanel>
            )
          })
        }
      </SwipeableViews>
    </Box>
  );
}
